export default "__VITE_ASSET__DgYVRSQ1__"